// src/views/ocorrencias/OcorrenciasList.jsx
import React, { useState, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import ocorrenciasService from "../../services/ocorrenciasService";
import contasPagarService from "../../services/contasPagarService";
import condominiosService      from "../../services/condominiosService";
import contasContabeisService  from "../../services/contasContabeisService";
import { useAuth } from "../../contexts/AuthContext";
import OcorrenciaModal from "./OcorrenciaModal";
import AnexosUpload from "../../components/ui/AnexosUpload";
import DeleteModal from "../../components/ui/DeleteModal";
import Banner from "../../components/ui/Banner";
import ConfirmModal from "../../components/ui/ConfirmModal";

const fmtDt  = dt => { if(!dt) return "—"; try{ return new Date(dt).toLocaleString("pt-BR"); }catch{return dt;} };
const fmtMoeda = v => v!=null ? Number(v).toLocaleString("pt-BR",{style:"currency",currency:"BRL"}) : "—";

const PRIORIDADE = {
  Urgente: { background:"var(--bg-danger-soft)",color:"#991B1B",dot:"#EF4444" },
  Alta:    { background:"#FFF7ED",color:"#C2410C",dot:"#F97316" },
  Media:   { background:"var(--bg-warning-soft)",color:"#854D0E",dot:"#EAB308" },
  Baixa:   { background:"var(--bg-success-soft)",color:"#166534",dot:"#22C55E" },
};

const STATUS_STYLE = {
  Aberta:               {background:"var(--bg-danger-soft)",color:"#991B1B"},
  EmAnalise:            {background:"#FFF7ED",color:"#C2410C"},
  EmAndamento:          {background:"var(--bg-highlight)",color:"#1E40AF"},
  AguardandoCondomino:  {background:"#F5F3FF",color:"#6D28D9"},
  Resolvida:            {background:"var(--bg-success-soft)",color:"#166534"},
  Fechada:              {background:"var(--bg-page)",color:"var(--gray-600)"},
  Cancelada:            {background:"var(--bg-page)",color:"var(--gray-400)"},
};

const STATUS_LABEL = {
  Aberta:"Aberta", EmAnalise:"Em Análise", EmAndamento:"Em Andamento",
  AguardandoCondomino:"Aguard. Condômino", Resolvida:"Resolvida",
  Fechada:"Fechada", Cancelada:"Cancelada",
};

// Transições permitidas — espelha backend STATUS_TRANSICOES_VALIDAS
const TRANSICOES_VALIDAS = {
  Aberta:              ["EmAnalise","EmAndamento","Cancelada","Fechada","Resolvida"],
  EmAnalise:           ["EmAndamento","AguardandoCondomino","Resolvida","Cancelada"],
  EmAndamento:         ["EmAnalise","AguardandoCondomino","Resolvida","Cancelada"],
  AguardandoCondomino: ["EmAndamento","Resolvida","Cancelada"],
  Resolvida:           ["Fechada","EmAndamento"],
  Fechada:             [],
  Cancelada:           [],
};

const TP_LABEL = {
  Reclamacao:"Reclamação",Manutencao:"Manutenção",Solicitacao:"Solicitação",
  Infracao:"Infração",Acidente:"Acidente",Seguranca:"Segurança",
  Sugestao:"Sugestão",Outro:"Outro",
};

const TIMELINE_ICON = {
  Abertura:"bi-plus-circle-fill",Comentario:"bi-chat-fill",
  MudancaStatus:"bi-arrow-right-circle-fill",VinculoConta:"bi-link-45deg",
  AtribuicaoResponsavel:"bi-person-check-fill",Resolucao:"bi-check-circle-fill",
  Fechamento:"bi-lock-fill",Anexo:"bi-paperclip",
};

const TIMELINE_COLOR = {
  Abertura:"#3B82F6",Comentario:"#6B7280",MudancaStatus:"#8B5CF6",
  VinculoConta:"#F59E0B",AtribuicaoResponsavel:"#06B6D4",
  Resolucao:"#10B981",Fechamento:"#64748B",Anexo:"#F97316",
};

export default function OcorrenciasList() {
  const { condominioAtivo, isAdmin, isGerente } = useAuth();
  const { podeEditar } = useAuth();
  const canEdit = podeEditar("ocorrencias");
  const [condominios, setCondominios]   = useState([]);

  // Sync with navbar condominioAtivo — updates whenever user changes it
  useEffect(() => {
    if (condominioAtivo?.id) setIdCondo(String(condominioAtivo.id));
    else setIdCondo("");
  }, [condominioAtivo]);
  const [idCondo, setIdCondo]           = useState("");
  const [data, setData]                 = useState([]);
  const [totais, setTotais]             = useState([]);
  const [loading, setLoading]           = useState(false);
  const [pagination, setPagination]     = useState({total:0,totalPages:1});
  const [filtros, setFiltros]           = useState({tpOcorrencia:"",prioridade:"",status:"",dtIni:"",dtFim:"",search:"",page:1});
  const [selected, setSelected]         = useState(null); // ocorrência selecionada p/ timeline
  const [timeline, setTimeline]         = useState([]);
  const [anexos, setAnexos]             = useState([]);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  // Modais
  const [showModal, setShowModal]       = useState(false);
  const [editData, setEditData]         = useState(null);
  const [saving, setSaving]             = useState(false);
  // Status change
  const [showStatus, setShowStatus]     = useState(false);
  const [novoStatus, setNovoStatus]     = useState("");
  const [comentarioStatus, setComentarioStatus] = useState("");
  // Comentário
  const [showComentario, setShowComentario] = useState(false);
  const [comentario, setComentario]     = useState("");
  // Multa
  const [showMulta, setShowMulta]       = useState(false);
  const [contasContabeis, setContasContabeis] = useState([]);
  const [multaForm, setMultaForm]       = useState({vlrMulta:"",descricaoMulta:"",nrParcelas:"1",dtVencimento:""});
  const [savingMulta, setSavingMulta]   = useState(false);
  // Vincular pagar
  const [showVincularPagar, setShowVincularPagar] = useState(false);
  const [contasPagar, setContasPagar]   = useState([]);
  const [idContaPagarSel, setIdContaPagarSel] = useState("");
  // Relatório
  const [aba, setAba]                   = useState("lista");
  const [relData, setRelData]           = useState(null);
  const [relLoading, setRelLoading]     = useState(false);
  const [relFiltros, setRelFiltros]     = useState({dtIni:"",dtFim:""});

  // Banner + confirmação genérica
  const [banner, setBanner] = useState(null);
  const showBanner = (tipo, msg) => { setBanner({ tipo, msg }); setTimeout(()=>setBanner(null), 7000); };
  const [confirmacao, setConfirmacao] = useState(null);

  // Confirmação especial: cancelar ocorrência com multa vinculada
  const [confirmCancelMulta, setConfirmCancelMulta] = useState(false);

  useEffect(() => {
    condominiosService.listar({limit:100}).then(r=>{
      setCondominios(r.data);

    }).catch(()=>{});
  },[]);

  const carregar = useCallback(async () => {
    if(!idCondo) return;
    setLoading(true);
    try {
      const r = await ocorrenciasService.listar({idCondominio:idCondo,...filtros,limit:15});
      setData(r.data); setPagination(r.pagination); setTotais(r.totais||[]);
    } catch(e){console.error(e);}
    finally{setLoading(false);}
  },[idCondo,filtros]);

  useEffect(()=>{ if(aba==="lista") carregar(); },[carregar,aba]);

  // Carrega contas contábeis do tipo Receita para o modal de multa
  useEffect(() => {
    if (!idCondo) return;
    contasContabeisService.listar({idCondominio: idCondo, situacao:"ativo", natureza:"Analitica"})
      .then(r => setContasContabeis(r.data||[]))
      .catch(() => {});
  }, [idCondo]);

  const abrirTimeline = async (oc) => {
    setSelected(oc); setLoadingTimeline(true);
    try {
      const r = await ocorrenciasService.buscarPorId(oc.id);
      // Update selected with full data including idContaReceber
      if (r.data) setSelected({...r.data}); // use full data from server
      setTimeline(r.data.timeline||[]);
      setAnexos(r.data.anexos||[]);
    } catch{}
    setLoadingTimeline(false);
  };

  const handleSave = async (form) => {
    setSaving(true);
    try {
      const payload = {...form,idCondominio:idCondo};
      if(form.id) await ocorrenciasService.atualizar(form.id,payload);
      else        await ocorrenciasService.criar(payload);
      setShowModal(false);
      showBanner("success", form.id ? "Ocorrência atualizada." : "Ocorrência registrada.");
      await carregar();
    } catch(e){ showBanner("error", e.message || "Erro ao salvar ocorrência."); }
    finally{setSaving(false);}
  };

  const executarMudarStatus = async (estornarMulta) => {
    try {
      await ocorrenciasService.mudarStatus(selected.id, {
        novoStatus, comentario:comentarioStatus, estornarMulta
      });
      setShowStatus(false); setComentarioStatus(""); setNovoStatus("");
      setConfirmCancelMulta(false);
      showBanner("success", "Status atualizado.");
      await carregar();
      const r = await ocorrenciasService.buscarPorId(selected.id);
      setSelected(r.data); setTimeline(r.data.timeline||[]);
    } catch(e){
      setConfirmCancelMulta(false);
      showBanner("error", e.message || "Erro ao mudar status.");
    }
  };

  const handleMudarStatus = async () => {
    if(!novoStatus) return showBanner("warning", "Selecione o novo status.");
    // Se cancelando ocorrência com multa vinculada, abre modal de decisão
    if (novoStatus === "Cancelada" && selected?.idContaReceber) {
      setConfirmCancelMulta(true);
      return;
    }
    await executarMudarStatus(false);
  };

  const handleComentar = async () => {
    if(!comentario.trim()) return showBanner("warning", "Digite um comentário.");
    try {
      await ocorrenciasService.comentar(selected.id,{comentario});
      setShowComentario(false); setComentario("");
      showBanner("success", "Comentário adicionado.");
      const r=await ocorrenciasService.buscarPorId(selected.id);
      setTimeline(r.data.timeline||[]);
    } catch(e){ showBanner("error", e.message || "Erro ao adicionar comentário."); }
  };

  const handleGerarMulta = async () => {
    if (!multaForm.vlrMulta) return showBanner("warning", "Informe o valor da multa.");
    if (!multaForm.idContaContabil) return showBanner("warning", "Selecione a Conta Contábil para classificar a multa no financeiro.");
    setSavingMulta(true);
    try {
      await ocorrenciasService.gerarMulta(selected.id, multaForm);
      setShowMulta(false);
      setMultaForm({vlrMulta:"",descricaoMulta:"",nrParcelas:"1",dtVencimento:"",idContaContabil:"",_showContaList:false,_searchConta:""});
      showBanner("success", "Multa gerada com sucesso.");
      await carregar();
      const r = await ocorrenciasService.buscarPorId(selected.id);
      setSelected(r.data); setTimeline(r.data.timeline||[]);
    } catch(e){ showBanner("error", e.message || "Erro ao gerar multa."); }
    setSavingMulta(false);
  };

  const abrirVincularPagar = async () => {
    try {
      const r=await contasPagarService.listar({idCondominio:idCondo,status:"Aberto",limit:100});
      setContasPagar(r.data||[]); setShowVincularPagar(true);
    } catch(e){ showBanner("error", e.message || "Erro ao carregar contas a pagar."); }
  };

  const handleVincularPagar = async () => {
    if(!idContaPagarSel) return showBanner("warning", "Selecione a conta a pagar.");
    try {
      await ocorrenciasService.vincularPagar(selected.id,{idContaPagar:idContaPagarSel});
      setShowVincularPagar(false); setIdContaPagarSel("");
      showBanner("success", "Conta a pagar vinculada.");
      const r=await ocorrenciasService.buscarPorId(selected.id);
      setSelected(r.data); setTimeline(r.data.timeline||[]);
    } catch(e){ showBanner("error", e.message || "Erro ao vincular conta a pagar."); }
  };

  const gerarRelatorio = async () => {
    setRelLoading(true);
    try {
      const r=await ocorrenciasService.relatorio({idCondominio:idCondo,...relFiltros});
      setRelData(r);
    } catch(e){ showBanner("error", e.message || "Erro ao gerar relatório."); }
    setRelLoading(false);
  };

  const setF = (f,v) => setFiltros(p=>({...p,[f]:v,page:1}));
  const totalPorStatus = (s) => totais.find(t=>t.status===s)?.qtd||0;

  const handleUploadAnexo = async (a) => {
    if (!selected?.id) {
      showBanner("warning", "Salve a ocorrência antes de adicionar anexos.");
      return;
    }
    try {
      const resp = await ocorrenciasService.uploadAnexo(selected.id, a);
      if (resp?.data?.id) {
        setAnexos(prev => [...prev, resp.data]);
      } else {
        const lista = await ocorrenciasService.listarAnexos(selected.id).catch(()=>null);
        if (lista?.data) setAnexos(lista.data);
      }
      showBanner("success", "Anexo enviado.");
    } catch(e){ showBanner("error", e?.message || "Erro ao enviar anexo."); }
  };

  const handleRemoverAnexo = (idAnexo) => {
    setConfirmacao({
      titulo: "Remover anexo",
      mensagem: "O anexo será excluído permanentemente. Deseja continuar?",
      textoOk: "Remover",
      perigo: true,
      onConfirm: async () => {
        try {
          await ocorrenciasService.deletarAnexo(selected.id, idAnexo);
          setAnexos(p=>p.filter(a=>a.id!==idAnexo));
          setConfirmacao(null);
          showBanner("success", "Anexo removido.");
        } catch(e){
          setConfirmacao(null);
          showBanner("error", e?.message || "Erro ao remover anexo.");
        }
      },
    });
  };

  const handleDownloadAnexo = async (a) => {
    try {
      let href, filename;
      if (a?.base64) {
        const b64 = a.base64.startsWith("data:") ? a.base64
          : `data:${a.mimeType||a.tpArquivo||"application/octet-stream"};base64,${a.base64}`;
        href     = b64;
        filename = a.nmArquivo || a.nomeOriginal || "anexo";
      } else {
        const r = await ocorrenciasService.downloadAnexo(selected.id, a.id);
        href     = `data:${r.data?.mimeType||"application/octet-stream"};base64,${r.data?.base64}`;
        filename = r.data?.nmArquivo || r.data?.nomeOriginal || "anexo";
      }
      const link = document.createElement("a");
      link.href = href; link.download = filename;
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
    } catch(e){ showBanner("error", e?.message || "Erro ao baixar."); }
  };

  return (
    <div>
      {/* Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title"><i className="bi bi-exclamation-circle me-2" style={{color:"var(--primary)",fontSize:22}}/>Ocorrências</h1>
          <p className="page-subtitle">Gerencie reclamações, manutenções, infrações e solicitações</p>
        </div>
        <div className="d-flex gap-2 align-items-center flex-wrap">

          {aba==="lista"&&<button className="btn btn-primary" onClick={()=>{setEditData(null);setShowModal(true);}} disabled={!idCondo || !canEdit}><i className="bi bi-plus-lg"/> Nova Ocorrência</button>}
        </div>
      </div>

      {banner && (
        <Banner tipo={banner.tipo} onClose={()=>setBanner(null)}>
          {banner.msg}
        </Banner>
      )}

      {/* Stats de status */}
      {aba==="lista"&&idCondo&&(
        <div className="row g-2 mb-3">
          {[
            {s:"Aberta",label:"Abertas",icon:"bi-exclamation-circle"},
            {s:"EmAndamento",label:"Em Andamento",icon:"bi-arrow-repeat"},
            {s:"AguardandoCondomino",label:"Aguard. Condômino",icon:"bi-person-exclamation"},
            {s:"Resolvida",label:"Resolvidas",icon:"bi-check-circle"},
          ].map(({s,label,icon})=>(
            <div className="col-6 col-md-3" key={s}>
              <div className="stat-card" style={{cursor:"pointer",borderLeft:`3px solid ${STATUS_STYLE[s]?.background||"#ccc"}`}}
                onClick={()=>setF("status",filtros.status===s?"":s)}>
                <div style={{width:38,height:38,borderRadius:8,background:STATUS_STYLE[s]?.background,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <i className={`bi ${icon}`} style={{color:STATUS_STYLE[s]?.color,fontSize:18}}/>
                </div>
                <div><div style={{fontSize:22,fontWeight:700}}>{totalPorStatus(s)}</div><div className="stat-label">{label}</div></div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Sub-abas */}
      <div className="card">
        <div style={{borderBottom:"1px solid var(--gray-200)",padding:"0 16px",display:"flex",gap:4}}>
          {[{id:"lista",label:"Ocorrências",icon:"bi-list-ul"},{id:"relatorio",label:"Relatório",icon:"bi-bar-chart-line"}].map(t=>(
            <button key={t.id} className="btn border-0 d-flex align-items-center gap-1"
              style={{fontSize:13,padding:"12px 14px",borderRadius:0,borderBottom:aba===t.id?"2px solid var(--primary)":"2px solid transparent",
                fontWeight:aba===t.id?600:400,color:aba===t.id?"var(--primary)":"var(--gray-500)",background:"transparent"}}
              onClick={()=>setAba(t.id)}>
              <i className={`bi ${t.icon}`}/>{t.label}
            </button>
          ))}
        </div>

        {aba==="lista"&&(
          <>
            {/* Filtros */}
            <div style={{padding:"10px 16px",borderBottom:"1px solid var(--gray-100)",display:"flex",gap:8,flexWrap:"wrap",alignItems:"flex-end"}}>
              {[{label:"Tipo",field:"tpOcorrencia",opts:[["","Todos os tipos"],...Object.entries(TP_LABEL)]},
                {label:"Prioridade",field:"prioridade",opts:[["","Todas"],["Urgente","Urgente"],["Alta","Alta"],["Media","Média"],["Baixa","Baixa"]]},
                {label:"Status",field:"status",opts:[["","Todos"],...Object.entries(STATUS_LABEL)]}
              ].map(({label,field,opts})=>(
                <div key={field}>
                  <div style={{fontSize:11,fontWeight:600,color:"var(--gray-500)",marginBottom:2}}>{label}</div>
                  <select className="form-select form-select-sm" style={{width:"auto"}} value={filtros[field]} onChange={e=>setF(field,e.target.value)}>
                    {opts.map(([v,l])=><option key={v} value={v}>{l}</option>)}
                  </select>
                </div>
              ))}
              <div>
                <div style={{fontSize:11,fontWeight:600,color:"var(--gray-500)",marginBottom:2}}>De</div>
                <input type="date" className="form-control form-control-sm" style={{width:140}} value={filtros.dtIni} onChange={e=>setF("dtIni",e.target.value)}/>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:600,color:"var(--gray-500)",marginBottom:2}}>Até</div>
                <input type="date" className="form-control form-control-sm" style={{width:140}} value={filtros.dtFim} onChange={e=>setF("dtFim",e.target.value)}/>
              </div>
              <div style={{flex:"1 1 220px",minWidth:200}}>
                <div style={{fontSize:11,fontWeight:600,color:"var(--gray-500)",marginBottom:2}}>Buscar</div>
                <input type="search" className="form-control form-control-sm" placeholder="Título ou descrição..." value={filtros.search}
                  onChange={e=>setF("search",e.target.value)}/>
              </div>
              <div className="mt-auto"><button className="btn btn-outline-secondary btn-sm" onClick={carregar}><i className="bi bi-arrow-clockwise"/></button></div>
              {(filtros.tpOcorrencia||filtros.prioridade||filtros.status||filtros.dtIni||filtros.dtFim||filtros.search) && (
                <div className="mt-auto">
                  <button className="btn btn-link btn-sm" style={{fontSize:11}}
                    onClick={()=>setFiltros({tpOcorrencia:"",prioridade:"",status:"",dtIni:"",dtFim:"",search:"",page:1})}>
                    <i className="bi bi-x-circle me-1"/>Limpar filtros
                  </button>
                </div>
              )}
            </div>

            {/* Layout: lista + painel timeline */}
            <div style={{display:"flex",minHeight:400}}>
              {/* Tabela */}
              <div style={{flex:1,minWidth:0,overflow:"auto"}}>
                <table className="table table-custom mb-0">
                  <thead><tr><th>Prioridade</th><th>Ocorrência</th><th>Tipo</th><th>Unidade</th><th>Prazo</th><th>Status</th><th style={{width:80}}>Ações</th></tr></thead>
                  <tbody>
                    {loading?<tr><td colSpan={7} className="text-center py-4"><span className="spinner-border spinner-border-sm text-primary me-2"/></td></tr>
                    :!idCondo?<tr><td colSpan={7} className="text-center py-4" style={{color:"var(--gray-400)"}}>Selecione um condomínio</td></tr>
                    :data.length===0?<tr><td colSpan={7} className="text-center py-4" style={{color:"var(--gray-400)"}}>Nenhuma ocorrência encontrada</td></tr>
                    :data.map(oc=>{
                      const pr = PRIORIDADE[oc.prioridade]||PRIORIDADE.Media;
                      const st = STATUS_STYLE[oc.status]||STATUS_STYLE.Aberta;
                      const vencida = oc.vencida===1||oc.vencida==="1";
                      return (
                        <tr key={oc.id} style={{background:selected?.id===oc.id?"#EFF6FF":"",cursor:"pointer"}} onClick={()=>abrirTimeline(oc)}>
                          <td>
                            <span style={{...pr,padding:"3px 10px",borderRadius:12,fontSize:11.5,fontWeight:700,display:"flex",alignItems:"center",gap:5,width:"fit-content"}}>
                              <span style={{width:7,height:7,borderRadius:"50%",background:pr.dot,display:"inline-block"}}/>
                              {oc.prioridade}
                            </span>
                          </td>
                          <td>
                            <div style={{fontWeight:600,fontSize:13,color:"var(--gray-800)"}}>{oc.titulo}</div>
                            <div style={{fontSize:11.5,color:"var(--gray-400)"}}>#{oc.id} • {oc.qtdInteracoes} interação(ões)</div>
                          </td>
                          <td><span style={{background:"var(--gray-100)",color:"var(--gray-600)",padding:"2px 8px",borderRadius:10,fontSize:11.5}}>{TP_LABEL[oc.tpOcorrencia]||oc.tpOcorrencia}</span></td>
                          <td style={{fontSize:12.5}}>{oc.unidade?`${oc.unidade}${oc.bloco?" / Bl."+oc.bloco:""}`:"—"}</td>
                          <td>
                            {oc.dtPrazo
                              ? <span style={{fontSize:12,color:vencida?"#991B1B":"var(--gray-500)",fontWeight:vencida?700:400}}>
                                  {vencida&&<i className="bi bi-exclamation-triangle-fill me-1"/>}
                                  {new Date(oc.dtPrazo).toLocaleDateString("pt-BR")}
                                </span>
                              : <span style={{color:"var(--gray-300)"}}>—</span>
                            }
                          </td>
                          <td><span style={{...st,padding:"2px 9px",borderRadius:12,fontSize:11.5,fontWeight:600}}>{STATUS_LABEL[oc.status]||oc.status}</span></td>
                          <td>
                            <button className="btn btn-outline-secondary btn-sm btn-icon" title="Editar"
                              onClick={e=>{e.stopPropagation();setEditData(oc);setShowModal(true);}} disabled={!canEdit}>
                              <i className="bi bi-pencil"/>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Painel Timeline */}
              {selected&&(
                <div style={{width:360,flexShrink:0,borderLeft:"1px solid var(--gray-200)",display:"flex",flexDirection:"column",maxHeight:700}}>
                  {/* Header */}
                  <div style={{padding:"12px 16px",borderBottom:"1px solid var(--gray-100)",background:"var(--gray-50)"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div>
                        <div style={{fontWeight:700,fontSize:13,color:"var(--gray-800)"}}>{selected.titulo}</div>
                        <div style={{fontSize:11.5,color:"var(--gray-400)"}}>#{selected.id} • {TP_LABEL[selected.tpOcorrencia]}</div>
                      </div>
                      <button style={{background:"none",border:"none",cursor:"pointer",color:"var(--gray-400)",fontSize:16}} onClick={()=>setSelected(null)}>
                        <i className="bi bi-x-lg"/>
                      </button>
                    </div>
                    {/* Ações rápidas */}
                    <div style={{display:"flex",gap:4,marginTop:8,flexWrap:"wrap"}}>
                      {!["Resolvida","Fechada","Cancelada"].includes(selected.status)&&(
                        <button className="btn btn-outline-secondary btn-sm" style={{fontSize:11}} onClick={()=>setShowStatus(true)}>
                          <i className="bi bi-arrow-right-circle me-1"/>Status
                        </button>
                      )}
                      <button className="btn btn-outline-secondary btn-sm" style={{fontSize:11}} onClick={()=>setShowComentario(true)}>
                        <i className="bi bi-chat me-1"/>Comentar
                      </button>
                      {((selected.tpOcorrencia||"").toLowerCase().replace(/ç/g,"c").replace(/ã/g,"a").replace(/ê/g,"e")==="infracao")&&(
                        selected.idContaReceber ? (
                          <span style={{fontSize:11,color:"#15803D",background:"var(--bg-success-soft)",border:"1px solid #86EFAC",borderRadius:6,padding:"2px 8px"}}>
                            <i className="bi bi-check-circle me-1"/>Multa Gerada
                          </span>
                        ) : (
                          <button className="btn btn-outline-warning btn-sm" style={{fontSize:11,borderColor:"#F59E0B",color:"#B45309"}} onClick={()=>{ setMultaForm(p=>({...p, descricaoMulta:`Multa - ${selected?.titulo||""}`, dtVencimento:new Date().toISOString().split("T")[0]})); setShowMulta(true); }}>
                            <i className="bi bi-cash me-1"/>Lançar Multa
                          </button>
                        )
                      )}
                      {selected.tpOcorrencia==="Manutencao"&&!selected.idContaPagar&&(
                        <button className="btn btn-outline-secondary btn-sm" style={{fontSize:11}} onClick={abrirVincularPagar}>
                          <i className="bi bi-link me-1"/>Vincular Pagar
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Formulários inline */}
                  {showStatus&&(
                    <div style={{padding:"10px 16px",background:"var(--bg-success-soft)",borderBottom:"1px solid var(--gray-100)"}}>
                      <div style={{fontSize:12,fontWeight:600,color:"#166534",marginBottom:6}}>Alterar Status</div>
                      <select className="form-select form-select-sm mb-2" value={novoStatus} onChange={e=>setNovoStatus(e.target.value)}>
                        <option value="">Selecione...</option>
                        {(TRANSICOES_VALIDAS[selected.status]||[]).map(v =>
                          <option key={v} value={v}>{STATUS_LABEL[v]||v}</option>
                        )}
                      </select>
                      {(!TRANSICOES_VALIDAS[selected.status]||TRANSICOES_VALIDAS[selected.status].length===0) && (
                        <div style={{fontSize:11.5,color:"#991B1B",marginBottom:6}}>
                          <i className="bi bi-info-circle me-1"/>
                          Esta ocorrência está {STATUS_LABEL[selected.status]} e não permite mais transições.
                        </div>
                      )}
                      <input className="form-control form-control-sm mb-2" placeholder="Comentário (opcional)" value={comentarioStatus} onChange={e=>setComentarioStatus(e.target.value)}/>
                      <div style={{display:"flex",gap:6}}>
                        <button className="btn btn-success btn-sm" onClick={handleMudarStatus}>Confirmar</button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>setShowStatus(false)}>Cancelar</button>
                      </div>
                    </div>
                  )}
                  {showComentario&&(
                    <div style={{padding:"10px 16px",background:"var(--bg-highlight)",borderBottom:"1px solid var(--gray-100)"}}>
                      <div style={{fontSize:12,fontWeight:600,color:"var(--primary)",marginBottom:6}}>Adicionar Comentário</div>
                      <textarea className="form-control form-control-sm mb-2" rows={2} value={comentario} onChange={e=>setComentario(e.target.value)} placeholder="Digite seu comentário..."/>
                      <div style={{display:"flex",gap:6}}>
                        <button className="btn btn-primary btn-sm" onClick={handleComentar}>Enviar</button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>setShowComentario(false)}>Cancelar</button>
                      </div>
                    </div>
                  )}

                  {showVincularPagar&&(
                    <div style={{padding:"10px 16px",background:"#F5F3FF",borderBottom:"1px solid var(--gray-100)"}}>
                      <div style={{fontSize:12,fontWeight:600,color:"#6D28D9",marginBottom:6}}>Vincular Conta a Pagar</div>
                      <select className="form-select form-select-sm mb-2" value={idContaPagarSel} onChange={e=>setIdContaPagarSel(e.target.value)}>
                        <option value="">Selecione...</option>
                        {contasPagar.map(cp=><option key={cp.id} value={cp.id}>#{cp.id} — {cp.descricao}</option>)}
                      </select>
                      <div style={{display:"flex",gap:6}}>
                        <button className="btn btn-primary btn-sm" onClick={handleVincularPagar}>Vincular</button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>setShowVincularPagar(false)}>Cancelar</button>
                      </div>
                    </div>
                  )}

                  {/* Anexos da Ocorrência */}
                  {selected && (
                    <div style={{padding:"10px 16px",borderTop:"1px solid var(--gray-100)",borderBottom:"1px solid var(--gray-100)",background:"var(--gray-50)"}}>
                      <div style={{fontSize:12,fontWeight:600,color:"var(--gray-600)",marginBottom:6}}>
                        <i className="bi bi-paperclip me-1"/>Documentos Anexados
                        {anexos.length>0&&<span style={{marginLeft:6,background:"var(--primary)",color:"#fff",borderRadius:10,padding:"0 6px",fontSize:10}}>{anexos.length}</span>}
                      </div>
                      <AnexosUpload
                        anexos={anexos}
                        onAdd={handleUploadAnexo}
                        onRemove={(idOrIdx)=>{ const a = anexos.find(x=>x.id===idOrIdx)??anexos[idOrIdx]; if(a?.id) handleRemoverAnexo(a.id); }}
                        onDownload={(a)=>handleDownloadAnexo(a)}
                        label="Anexar Documento"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                        maxSizeMB={10}/>
                    </div>
                  )}

                  {/* Timeline */}
                  <div style={{flex:1,overflowY:"auto",padding:"12px 16px"}}>
                    {loadingTimeline?<div className="text-center py-4"><span className="spinner-border spinner-border-sm text-primary"/></div>
                    :timeline.length===0?<p style={{fontSize:12.5,color:"var(--gray-400)",textAlign:"center"}}>Sem interações</p>
                    :timeline.map((ev,i)=>(
                      <div key={ev.id} style={{display:"flex",gap:10,marginBottom:i<timeline.length-1?16:0}}>
                        <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                          <div style={{width:30,height:30,borderRadius:"50%",background:TIMELINE_COLOR[ev.tpEvento]||"#6B7280",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                            <i className={`bi ${TIMELINE_ICON[ev.tpEvento]||"bi-circle-fill"}`} style={{color:"#fff",fontSize:13}}/>
                          </div>
                          {i<timeline.length-1&&<div style={{width:2,flex:1,background:"var(--gray-200)",margin:"4px 0"}}/>}
                        </div>
                        <div style={{flex:1,paddingBottom:4}}>
                          <div style={{fontSize:12.5,color:"var(--gray-700)"}}>{ev.descricao}</div>
                          <div style={{fontSize:11,color:"var(--gray-400)",marginTop:3}}>
                            {ev.registradoPor} • {fmtDt(ev.createdAt)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Paginação */}
            {pagination.totalPages>1&&(
              <div className="pagination-wrapper">
                <span className="pagination-info">{pagination.total} ocorrência(s)</span>
                <nav><ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${filtros.page===1?"disabled":""}`}><button className="page-link" onClick={()=>setF("page",filtros.page-1)}><i className="bi bi-chevron-left"/></button></li>
                  {Array.from({length:pagination.totalPages},(_,i)=>(<li key={i+1} className={`page-item ${filtros.page===i+1?"active":""}`}><button className="page-link" onClick={()=>setF("page",i+1)}>{i+1}</button></li>))}
                  <li className={`page-item ${filtros.page===pagination.totalPages?"disabled":""}`}><button className="page-link" onClick={()=>setF("page",filtros.page+1)}><i className="bi bi-chevron-right"/></button></li>
                </ul></nav>
              </div>
            )}
          </>
        )}

        {/* ── ABA RELATÓRIO ── */}
        {aba==="relatorio"&&(
          <div style={{padding:16}}>
            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-funnel"/> Filtros</div>
              <div className="row g-3 align-items-end">
                <div className="col-md-3"><label className="form-label">De</label><input type="date" className="form-control" value={relFiltros.dtIni} onChange={e=>setRelFiltros(p=>({...p,dtIni:e.target.value}))}/></div>
                <div className="col-md-3"><label className="form-label">Até</label><input type="date" className="form-control" value={relFiltros.dtFim} onChange={e=>setRelFiltros(p=>({...p,dtFim:e.target.value}))}/></div>
                <div className="col-md-2"><button className="btn btn-primary w-100" onClick={gerarRelatorio} disabled={relLoading||!idCondo}>{relLoading?<span className="spinner-border spinner-border-sm"/>:<><i className="bi bi-bar-chart-line me-1"/>Gerar</>}</button></div>
              </div>
            </div>
            {relData&&(
              <div className="row g-3">
                {/* Tempo médio e vencidas */}
                <div className="col-md-4">
                  <div style={{background:"var(--bg-highlight)",borderRadius:10,padding:"16px 20px",textAlign:"center"}}>
                    <div style={{fontSize:32,fontWeight:700,color:"var(--primary)"}}>{relData.tempoMedioHoras}h</div>
                    <div style={{fontSize:13,color:"var(--gray-500)"}}>Tempo médio de resolução</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div style={{background:"var(--bg-danger-soft)",borderRadius:10,padding:"16px 20px",textAlign:"center"}}>
                    <div style={{fontSize:32,fontWeight:700,color:"#991B1B"}}>{relData.qtdVencidas}</div>
                    <div style={{fontSize:13,color:"var(--gray-500)"}}>Ocorrências com prazo vencido</div>
                  </div>
                </div>
                {/* Por tipo */}
                <div className="col-md-6">
                  <div className="form-section">
                    <div className="form-section-title"><i className="bi bi-tags"/> Por Tipo</div>
                    {relData.porTipo?.map(t=>(
                      <div key={t.tpOcorrencia} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid var(--gray-100)",fontSize:13}}>
                        <span>{TP_LABEL[t.tpOcorrencia]||t.tpOcorrencia}</span>
                        <strong>{t.qtd}</strong>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Por prioridade */}
                <div className="col-md-6">
                  <div className="form-section">
                    <div className="form-section-title"><i className="bi bi-flag"/> Por Prioridade</div>
                    {relData.porPrioridade?.map(p=>{
                      const pr=PRIORIDADE[p.prioridade]||PRIORIDADE.Media;
                      return (
                        <div key={p.prioridade} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid var(--gray-100)",fontSize:13}}>
                          <span style={{...pr,padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:600}}>{p.prioridade}</span>
                          <strong>{p.qtd}</strong>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>


      {/* Modal Lançar Multa - Portal para escapar do backdrop-filter */}
      {showMulta && ReactDOM.createPortal((
        <div className="modal-overlay" onClick={()=>setShowMulta(false)}>
          <div className="modal-box" style={{maxWidth:420}} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h6 className="modal-title">
                <i className="bi bi-cash me-2" style={{color:"#B45309"}}/>
                Lançar Multa — #{selected?.id}
              </h6>
              <button className="btn-close" onClick={()=>setShowMulta(false)}/>
            </div>
            <div className="modal-body">
              {/* Info condômino/unidade */}
              <div style={{background:"var(--bg-surface-alt)",borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12.5,color:"var(--gray-600)",border:"1px solid var(--border-color)"}}>
                <div><strong>Ocorrência:</strong> #{selected?.id} — {selected?.titulo}</div>
                {selected?.nmCondomino && <div><strong>Condômino:</strong> {selected.nmCondomino}</div>}
                {selected?.unidade && <div><strong>Unidade:</strong> {selected.unidade}{selected.bloco?` / Bl.${selected.bloco}`:""}</div>}
              </div>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>
                    Conta Contábil <span className="required-mark">*</span>
                    <small style={{fontSize:10,color:"var(--gray-400)",fontWeight:400,marginLeft:4}}>({contasContabeis.length} contas)</small>
                  </label>
                  <select className="form-select" style={{color:"#1e293b",background:"var(--bg-surface)"}} value={multaForm.idContaContabil}
                    onChange={e=>setMultaForm(p=>({...p,idContaContabil:e.target.value}))}>
                    <option value="">— Selecione a conta contábil —</option>
                    {contasContabeis.map(cc=>(
                      <option key={cc.id} value={cc.id}>{cc.classificacaoContabil} — {cc.descConta}</option>
                    ))}
                  </select>
                  {!multaForm.idContaContabil && <small style={{color:"#EF4444",fontSize:11}}>Obrigatória para lançar no financeiro</small>}
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>Valor da Multa (R$) <span className="required-mark">*</span></label>
                  <input className="form-control" type="number" step="0.01" min="0"
                    placeholder="0,00" value={multaForm.vlrMulta}
                    onChange={e=>setMultaForm(p=>({...p,vlrMulta:e.target.value}))} autoFocus/>
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>Nº de Parcelas</label>
                  <input className="form-control" type="number" min="1" max="12"
                    placeholder="1" value={multaForm.nrParcelas}
                    onChange={e=>setMultaForm(p=>({...p,nrParcelas:e.target.value}))}/>
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>Data de Vencimento</label>
                  <input type="date" className="form-control" value={multaForm.dtVencimento}
                    onChange={e=>setMultaForm(p=>({...p,dtVencimento:e.target.value}))}/>
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold" style={{fontSize:13}}>Descrição</label>
                  <input className="form-control" placeholder="Motivo da multa"
                    value={multaForm.descricaoMulta}
                    onChange={e=>setMultaForm(p=>({...p,descricaoMulta:e.target.value}))}/>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline-secondary btn-sm" onClick={()=>setShowMulta(false)}>
                Cancelar
              </button>
              <button className="btn btn-warning btn-sm" onClick={handleGerarMulta} disabled={savingMulta}
                style={{fontWeight:600}}>
                {savingMulta
                  ? <><span className="spinner-border spinner-border-sm me-1"/>Gerando...</>
                  : <><i className="bi bi-cash me-1"/>Gerar Multa</>}
              </button>
            </div>
          </div>
        </div>
      ), document.body)}

      <OcorrenciaModal show={showModal} onClose={()=>setShowModal(false)} onSave={handleSave}
        editData={editData} saving={saving} idCondominio={idCondo}
        condominioNome={condominios.find(c=>String(c.id)===String(idCondo))?.nmFantasia||""}/>

      {/* Confirmação genérica */}
      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk || "Confirmar"}
          textoCancelar={confirmacao.textoCancelar || "Cancelar"}
          perigo={!!confirmacao.perigo}
          onConfirm={confirmacao.onConfirm}
          onCancel={()=>setConfirmacao(null)}
        />
      )}

      {/* Cancelamento com multa vinculada — decisão de estornar */}
      {confirmCancelMulta && (
        <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} onClick={()=>setConfirmCancelMulta(false)}>
          <div className="modal-dialog modal-md modal-dialog-centered" onClick={e=>e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-exclamation-triangle text-warning me-2"/>
                  Cancelar ocorrência com multa
                </h5>
                <button className="btn-close" onClick={()=>setConfirmCancelMulta(false)}/>
              </div>
              <div className="modal-body" style={{fontSize:13}}>
                <p>Esta ocorrência possui uma multa vinculada (<strong>CR #{selected?.idContaReceber}</strong>).</p>
                <p>O que você deseja fazer?</p>
                <ul style={{paddingLeft:18, marginBottom:0}}>
                  <li><strong>Estornar a multa</strong>: cancela a ocorrência e também cancela o Contas a Receber em aberto.</li>
                  <li><strong>Manter a multa</strong>: cancela apenas a ocorrência. A multa continua a ser cobrada.</li>
                </ul>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={()=>setConfirmCancelMulta(false)}>
                  Voltar
                </button>
                <button className="btn btn-outline-warning" onClick={()=>executarMudarStatus(false)}>
                  Cancelar e manter a multa
                </button>
                <button className="btn btn-danger" onClick={()=>executarMudarStatus(true)}>
                  Cancelar e estornar a multa
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
